import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiHttpInterceptor } from './providers/api-http-interceptor';

@NgModule({
    declarations: [],
    imports: [
        HttpClientModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: ApiHttpInterceptor, multi: true }
    ]
})
export class HttpModule {}

